import commonMapping from "@/mapping/common";

const vlan_types_list = [
  {
    id: "vlan_by_bridge",
    value: "iptv_enable",
    config: "iptv",
    label: "vlan_by_bridge",
  },
  {
    id: "vlan_by_vlan",
    value: "vlan_enable",
    config: "vlan",
    label: "vlan_by_vlan",
  },
];

const isp_options_list = [
  {
    value: "orange",
    config: "orange_france_iptv",
    label: "orange_france_iptv",
  },
  {
    value: "singtel_singa_iptv",
    config: "singtel_singa_iptv",
    label: "singtel_singapore_iptv",
  },
  {
    value: "unifi_malaysia_iptv",
    config: "unifi_malaysia_iptv",
    label: "unifi_malaysia_iptv",
  },
  {
    value: "maxis_malaysia_iptv",
    config: "maxis_malaysia_iptv",
    label: "maxis_malaysia_iptv",
  },
  {
    value: "orange_france_dhcp",
    config: "orange_france_dhcp",
    label: "orange_dhcp",
  },
  {
    value: "orange_france_pppoe",
    config: "orange_france_pppoe",
    label: "orange_pppoe",
  },
  {
    value: "movistar_spain_pppoe",
    config: "movistar_spain_pppoe",
    label: "movi_spain_dhcp",
  },
  {
    value: "vodafone_spain_pppoe",
    config: "vodafone_spain_pppoe",
    label: "voda_spain_dhcp",
  },
  {
    value: "singtel_singapore_dhcp",
    config: "singtel_singapore_dhcp",
    label: "singtel_singa_dhcp",
  },
  {
    value: "unifi_malaysia_dhcp",
    config: "unifi_malaysia_dhcp",
    label: "unifi_malaysia_dhcp",
  },
  {
    value: "maxis_malaysia_dhcp",
    config: "maxis_malaysia_dhcp",
    label: "maxis_malaysia_dhcp",
  },
  {
    value: "others",
    config: "others",
    label: "Others",
  },
];

export const vlan = {
  vlan_enable: commonMapping.intToBoolean,
  free_isp_enable: commonMapping.intToBoolean,
  vlan_type: vlan_types_list,
  isp_type: isp_options_list,
};

export default vlan;
